import React from 'react'
import LegalPage from '../components/LegalPage'

const TermsOfService: React.FC = () => (
  <LegalPage
    document="termsOfService"
    sections={[
      'introduction',
      'acceptance',
      'serviceDescription',
      'userAccounts',
      'acceptableUse',
      'prohibitedActivities',
      { key: 'messages', subsections: ['moderation'] },
      'paymentTerms',
      'termination',
      'limitationOfLiability',
      'changesToTerms',
      'contact',
    ]}
  />
)

export default TermsOfService
